// Mirrors the administrative role allowlist; the API remains authoritative.
export const canViewFollowUpComparison = (role: unknown) =>
  typeof role === 'string' &&
  ['admin', 'platform_admin', 'super_admin', 'special_admin', 'super_platform_admin'].includes(role)
